import { Injectable, signal } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class PlannedEffortUpdateLoadingService {
  private readonly loadingState = signal(false)
  private loadingTimeout: number | null = null
  private safetyTimeout: number | null = null

  readonly isLoading = this.loadingState.asReadonly()

  /**
   * Sets the loading state to true with a 2 second safety timeout setting it to false again
   */
  startLoading(): void {
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout)
      this.loadingTimeout = null
    }

    if (this.safetyTimeout) {
      clearTimeout(this.safetyTimeout)
    }

    this.loadingState.set(true)

    // In case the stopLoading is never called we set loading to false after 2 seconds latest
    this.safetyTimeout = window.setTimeout(() => {
      this.loadingState.set(false)
      this.loadingTimeout = null
      this.safetyTimeout = null
    }, 2000)
  }

  /**
   * Sets the loading state to false with an additional delay of 750ms
   */
  stopLoading(): void {
    if (this.safetyTimeout) {
      clearTimeout(this.safetyTimeout)
      this.safetyTimeout = null
    }

    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout)
    }

    this.loadingTimeout = window.setTimeout(() => {
      this.loadingState.set(false)
      this.loadingTimeout = null
    }, 750)
  }
}
